/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-07-30 11:02:10
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-30 12:07:13
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/HtmlToText/useHtmlToText.ts
 */
import React from 'react';
import { asyncGetPlainText } from 'src/request/common';

const useHtml = (data: any) => {
  const { html } = data;
  const [text, setText] = React.useState('');
  const [loaded, setLoaded] = React.useState(false);

  const getText = (html) => {
    setLoaded(false);
    asyncGetPlainText(html).then((res: string) => {
      setLoaded(true);
      setText(res);
    });
  };

  React.useEffect(() => {
    if (html) {
      getText(html);
    } else {
      setLoaded(true);
      setText('');
    }
  }, [html]);

  return { loaded, text };
};
export { useHtml };
